import { render, staticRenderFns } from "./selectAdminCommunity.vue?vue&type=template&id=2b9ee41c&scoped=true"
import script from "./selectAdminCommunity.vue?vue&type=script&lang=js"
export * from "./selectAdminCommunity.vue?vue&type=script&lang=js"
import style0 from "./selectAdminCommunity.vue?vue&type=style&index=0&id=2b9ee41c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9ee41c",
  null
  
)

export default component.exports